import { useState, useEffect } from 'react'
import axios from 'axios'
import { Pagination, Spin, Tooltip } from 'antd'
import MyIcon from '../../components/general/icon'
import AppointmentDetail from './detail'


export default function Appointment() {
  const [appointmentData, setAppointmentData] = useState({})
  const [propsData, setPropsData] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(true)
  const [isAppointmentDetailVisible, setIsAppointmentDetailVisible] = useState(false)

  const getAppointmentData = () => {
    axios.post('/admin/appointment/records/get', { 
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setIsLoading(false)
          setAppointmentData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'records': response.data.records
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getAppointmentData()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage])

  const fillAppointmentDetail = (item) => {
    setIsAppointmentDetailVisible(true)
    setPropsData({ detail: item })
  }

  return (
    <div className="public-page">
      <Spin spinning={isLoading}>
        <div className="public-container">
          <div className="public-header">
            <div className="public-title">健身管理</div>
          </div>

          <div className='public-main-style'>
            <div className='public-main-style2'>
              <table className='public-main-style2-item'>
                <thead>
                  <tr className='public-main-style2-thead'>
                    <th style={{textAlign: 'left', paddingLeft: '20px'}}>预约日期</th>
                    <th style={{textAlign: 'left'}}>预约时间</th>
                    <th>
                      <div className='public-main-style2-title'>预约教练</div>
                    </th>
                    <th>
                      <div className='public-main-style2-title'>预约用户</div>
                    </th>
                    <th>课程详情</th>
                    <th style={{width: '80px'}}></th>
                  </tr>
                </thead>

                <tbody>
                  {appointmentData.records && (appointmentData.records.length > 0 ? (appointmentData.records.map((item) => (
                    <tr className='public-main-style2-tbody' key={item.oid} style={{ cursor: 'default'}}>
                      <td style={{textAlign: 'left', paddingLeft: '20px'}}>{item.appointment_date}</td>
                      <td style={{textAlign: 'left'}}>{item.start_time} - {item.end_time}</td>
                      <td>
                        <div className='public-main-style2-tuwen'>
                          <img src={item.coach_avatar_url} alt="" style={{width: '30px', height: '30px'}}/>
                          <span>{item.coach_name}</span>
                        </div>
                      </td>
                      <td>
                        <div className='public-main-style2-tuwen'>
                          <img src={item.user_avatar_url} alt="" style={{width: '30px', height: '30px'}}/>
                          <span>{item.user_name}</span>
                        </div>
                      </td>
                      <td>{item.course_description ? '已填写' : '未填写'}</td>
                      <td style={{width: '80px'}}>
                        <div className='public-main-style2-operation-box'>
                          <Tooltip placement="bottom" color='#1A1B1C' title="填写课程详情">
                            <div className='public-main-style2-operation' 
                              onClick={(event) => {event.stopPropagation(); fillAppointmentDetail(item)}}>
                              <MyIcon name='wenzhang' />
                            </div>
                          </Tooltip>
                        </div>
                      </td>
                    </tr>
                  ))) : (
                    <tr className='public-main-style2-tbodyEmpty'>
                      <td colSpan='6'><span>暂无数据</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div className='pagination'>
              <Pagination 
                current={currentPage}
                total={appointmentData.total}
                pageSize={20}
                onChange={(page) => setCurrentPage(page)}
                showTotal={(total) => `共${total}条`}
                showSizeChanger={false}
                hideOnSinglePage={true}
                showQuickJumper={true}
              />
            </div>
          </div>
        </div>

        {isAppointmentDetailVisible && <AppointmentDetail
          getAppointmentData={getAppointmentData}
          data={propsData}
          isOpen={isAppointmentDetailVisible} 
          isCancel={() => { setIsAppointmentDetailVisible(false) }} 
        />}
      </Spin>
    </div>
  )
}
